import { flatten } from "flat";
import fr from "./fr.json";

const frontendLocales: Record<string, Record<string, string>> = {
    fr: flatten(fr, { delimiter: "." }),
};

export const getFrontendLocale = (localeCode: string): Record<string, string> => frontendLocales[localeCode] ?? {};
